import React, { Component } from "react";

class AppointmentTooltip extends Component {
  componentDidMount() {
    document.addEventListener("touchend", this.handleClickOutside);
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("touchend", this.handleClickOutside);
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (!e.target.closest(".appointment-tooltip")) {
      this.props.onClose();
    }
  };

  render() {
    const { data, position, placement } = this.props;
    const { originalData = {} } = data || {};
    const hasValue = (val) =>
      val !== null && val !== undefined && String(val).trim() !== "";

    return (
      <>
        <div className="tooltip-overlay" />
        <div
          className={`appointment-tooltip placement-${placement}`}
          style={{
            top: `${position.top}px`,
            left: `${position.left}px`,
          }}
        >
          <div className="tooltip-arrow"></div>
          <div className="tooltip-content">
            {hasValue(data.custName) && (
              <div className="tooltip-row">
                <span className="tooltip-label">
                  {" "}
                  <svg
                    className="field-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </span>
                <span className="tooltip-value">{data.custName}</span>
              </div>
            )}
            {hasValue(data.cust_refer) && (
              <div className="tooltip-row">
                <span className="tooltip-label">
                  <svg
                    className="field-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="9" cy="7" r="4" />
                    <path d="M17 11v-1a4 4 0 0 0-4-4" />
                    <path d="M21 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M9 14a6 6 0 0 0-6 6" />
                  </svg>
                </span>
                <span className="tooltip-value">{data.cust_refer}</span>
              </div>
            )}
            {hasValue(originalData.appt_remark) && (
              <div className="tooltip-row">
                <span className="tooltip-label">
                  <svg
                    className="field-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path d="M12 2a4 4 0 0 0-4 4v1a4 4 0 0 0-4 4v1a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-1a4 4 0 0 0-4-4V6a4 4 0 0 0-4-4z" />
                    <path d="M12 16v6" />
                    <path d="M8 19h8" />
                  </svg>
                </span>
                <span className="tooltip-value">
                  {data.originalData.appt_remark}
                </span>
              </div>
            )}
            {hasValue(originalData.status) && (
              <div className="tooltip-row">
                <span className="tooltip-label">
                  <svg
                    className="field-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                </span>
                <span className="tooltip-value">
                  {data.originalData.status}
                </span>
              </div>
            )}
            {hasValue(originalData.staff) && (
              <div className="tooltip-row">
                <span className="tooltip-label">
                  {" "}
                  <svg
                    className="field-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="7" r="4" />
                    <path d="M5.5 21v-2a6.5 6.5 0 0 1 13 0v2" />
                    <path
                      d="M12 11v4l-1 6h2l-1-6z"
                      fill="currentColor"
                      opacity="0.3"
                    />
                    <path d="M11 11l1-1 1 1" />
                  </svg>
                </span>
                <span className="tooltip-value">{data.originalData.staff}</span>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default AppointmentTooltip;
